import React, { useState } from "react";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useTheme, useMediaQuery, CircularProgress } from "@mui/material";

import * as S from "./Styled";
import { categoriasClubeDoAluno } from "../../../../constants/HomeCupom/categoryIcon";
import { BotaoCupomBloco, BotaoCupomFundo, BotaoCupomTopo } from "../../../../components/Coupons/Styled";
import useCouponData from "../../../../hooks/useCouponData";
import OnlineOffer from "../../../../components/Coupons/OnlineOffer";
import { useCouponRoute } from "../../../../hooks/useCouponRoute";
import { useAlert } from "../../../../context/AlertContext";
import { STORE_IMAGES } from "../../../../constants/urls";
import Brightness5Icon from '@mui/icons-material/Brightness5';
import useCouponRedirect from "../../../../hooks/useCouponRedirect";
import { format } from "date-fns";
import CupomModal from "../../../../components/Modal/Cupom/Cupom";
import useUTMParams from "../../../../hooks/useUTMParams";
import { NewCoupons } from "./NewCoupons";

export default function CarouselCupons({logo, modalTitle,slug,name,page, category, type, incentiveId, userId, setLoadingRedirect, getcouponRedirect, utmSource, utmCampaign, showAlert, openCoupon, loadingRedirect, isAuthenticated}) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isTablet = useMediaQuery(theme.breakpoints.down("md"));
    const isLargeDesktop = useMediaQuery(theme.breakpoints.up("lg"));

    const itemsPerPage = isMobile ? 3 : isLargeDesktop ? 5 : isTablet ? 3 : 4;
    const itemWidth = isMobile ? 134 : isLargeDesktop ? 190 : 200;
    const gap = isMobile ? 16 : isLargeDesktop ? 20 : 31.5;
    const containerWidth = itemsPerPage * itemWidth + (itemsPerPage - 1) * gap;

    const [currentIndex, setCurrentIndex] = useState(0);
    const limit = '5'

    const { coupons, loadingCoupon, errorCoupon, totalPages } = useCouponData({
        slug,
        name,
        category,
        type,
        limit
    });

    // No desktop largo os 5 cards cabem lado a lado, sem carrossel
    const showArrows = !isLargeDesktop;
    const totalItems = coupons?.data?.length || 0;
    const maxIndex = Math.max(totalItems - itemsPerPage, 0);
    const safeIndex = Math.min(currentIndex, maxIndex);

    const handlePrev = () => setCurrentIndex(Math.max(safeIndex - 1, 0));
    const handleNext = () => setCurrentIndex(Math.min(safeIndex + 1, maxIndex));

    if (!coupons?.data) {
        return <CircularProgress size={24} color="inherit" />;
    }


    return (
        <div>
            <S.Container>
            <S.Title variant="h4" sx={{ fontFamily: "'Noto Sans', sans-serif" }}>
                Top 5 da semana
            </S.Title>


        {isMobile ? (
            <S.CarouselAreaMobile>
            <S.CarouselContentMobile>
                <NewCoupons
                coupons={coupons}
                setLoadingRedirect={setLoadingRedirect}
                getcouponRedirect={getcouponRedirect}
                utmSource={utmSource}
                utmCampaign={utmCampaign}
                userId={userId}
                incentiveId={incentiveId}
                showAlert={showAlert}
                openCoupon={openCoupon}
                loadingRedirect={loadingRedirect}
                itemWidth={itemWidth}
                isAuthenticated={isAuthenticated}
                topCoupons={true}
                isMobile={isMobile}
                slug={slug}
                modalTitle={modalTitle}
                logo={logo}
                />
            </S.CarouselContentMobile>
            </S.CarouselAreaMobile>
        ) : (
        <S.RelativeContainer>
            {showArrows && safeIndex > 0 && (
            <S.ArrowButtonLeft onClick={handlePrev}>
                <ArrowBackIosNewIcon />
            </S.ArrowButtonLeft>
            )}

            <S.CarouselArea width={containerWidth}>
            <S.CarouselContent
                gap={gap}
                translate={showArrows ? safeIndex * (itemWidth + gap) : 0}
            >
                <NewCoupons
            coupons={coupons}
            setLoadingRedirect={setLoadingRedirect}
            getcouponRedirect={getcouponRedirect}
            utmSource={utmSource}
            utmCampaign={utmCampaign}
            userId={userId}
            incentiveId={incentiveId}
            showAlert={showAlert}
            openCoupon={openCoupon}
            loadingRedirect={loadingRedirect}
            itemWidth={itemWidth}
            isAuthenticated={isAuthenticated}
            topCoupons={true}
            isMobile={isMobile}
            modalTitle={modalTitle}
            slug={slug}
            logo={logo}
            />
            </S.CarouselContent>
            </S.CarouselArea>

            {showArrows && safeIndex < maxIndex && (
            <S.ArrowButtonRight onClick={handleNext}>
                <ArrowForwardIosIcon />
            </S.ArrowButtonRight>
            )}
        </S.RelativeContainer>
        )
        }
            
            </S.Container>
        </div>
    );
}
